// extracted by mini-css-extract-plugin
export default {"detail_list":"DetailInfo_detail_list__sMrSD","item_container":"DetailInfo_item_container__e9U9F","title":"DetailInfo_title__6F7bg","detail":"DetailInfo_detail__CY9UZ"};